import React, { Component } from 'react';
import { connect } from "react-redux";
import $ from 'jquery';
import '../css/validations.css'
import ApiClient from '../libs/apiClient';
let apiClient = ApiClient.getInstance();

class FileUploaderModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            preUploadedFiles: [],
            showConciliaButton: false,
        };
    }

    //#region Modal Actions
    closeModal = () => {
        this.setState({ preUploadedFiles: [], showConciliaButton: false });
        $("#FileUploaderModal").modal("hide");
    }

    cleanFiles = () => {
        this.setState({ preUploadedFiles: [], showConciliaButton: false });
    }
    //#endregion

    //#region Upload Actions
    preloadFiles = (event) => {
        const { preUploadedFiles } = this.state;
        const { notificationReducer: { showAlert } } = this.props
        const files = event.target.files;

        let showConciliaButton = this.state.showConciliaButton;

        for (let i = 0; i < files.length; i++) {
            const file = files[i];
            if (file.type !== 'text/plain') { showAlert({ type: 'warning', message: `El archivo "${file.name}" no es un archivo de texto válido`}, 5000); }
            else {
                const fileExists = preUploadedFiles.find(({name}) => name === file.name);
                if (fileExists) { showAlert({ type: 'warning', message: `El archivo "${file.name}" ya se encuentra cargado en la lista actual`}, 5000); }
                else { 
                    showConciliaButton = true;
                    file.phase = 0;
                    file.message = '';
                    preUploadedFiles.push(file); 
                }
            }
        }

        this.setState({ preUploadedFiles, showConciliaButton });
    };

    unloadFiles = (index) => {
        const { preUploadedFiles } = this.state;
        let showConciliaButton = this.state.showConciliaButton;

        preUploadedFiles.splice(index, 1);
        if (preUploadedFiles.length === 0) { showConciliaButton = false }
        this.setState({ preUploadedFiles, showConciliaButton});
    };

    uploadFiles = async () => {
        const { preUploadedFiles } = this.state;
        const { enableSpinner, notificationReducer: { showAlert }, } = this.props;
        let error = false;
        let correctFiles = [];
        await this.setState({ showConciliaButton: false });

        enableSpinner(true);
        for (let i = 0; i < preUploadedFiles.length; i++) {
            const file = preUploadedFiles[i];
            if (file.phase === 0) {
                file.phase = 1;
                await this.setState({ preUploadedFiles });

                const responseAPI = await apiClient.uploadPaymentFile(file);
                file.message = responseAPI.data.message ?? '';

                if (responseAPI.status === 0) {
                    error = true;
                    file.phase = -1;
                    showAlert({ type: 'warning', message: responseAPI.message}, 5000);
                } else {
                    file.phase = 2;
                    correctFiles.push(responseAPI.data);
                    showAlert({ type: 'info', message: responseAPI.message}, 5000);
                }

                await this.setState({ preUploadedFiles });
            }
        }
        enableSpinner(false);

        if (!error) { showAlert({ type: 'success', message: `Archivos cargados correctamente`}, 5000); }

        if (correctFiles.length > 0) {
            showAlert({ type: 'info', message: `Procesando pagos`}, 5000);
            for (const file of preUploadedFiles) { if (file.phase === 2) {file.phase = 3} }
            error = false;
            enableSpinner(true);
            const responsePaymentsAPI = await apiClient.processPaymentFiles({payments: correctFiles});
            enableSpinner(false);
            showAlert({ type: 'info', message: "Proceso terminado"}, 5000);

            for (let i = 0; i < preUploadedFiles.length; i++) {
                let file = preUploadedFiles[i];
                const response = responsePaymentsAPI.data.find(({FileName}) => FileName === file.name);
                if (!response) { file.phase = -1; file.message = "Ocurrió un error inesperado"; }
                else { file.phase = response.Status; file.message = response.Message || ""; }
            }
            await this.setState({ preUploadedFiles });
        }
    }
    //#endregion

    //#region RENDER
    render() {
        const { preUploadedFiles, showConciliaButton } = this.state;
        return (
            <div
                className="modal fade bd-example-modal-xl modal-open scroll"
                id="FileUploaderModal"
                role="dialog"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
                data-backdrop="static">
                <div className="modal-dialog modal-xl modal-open" role="file">
                    <div className="modal-content">
                        <div className="modal-header text-white"
                            style={{ backgroundColor: '#343a40', borderRadius: '0' }}>
                            <h4 className="modal-title" id="modal-basic-title ">
                                Selección de archivos de pago
                            </h4>
                            <button type="button" className="close" aria-label="Close" onClick={this.closeModal}>
                                <span className="text-white" aria-hidden="true">
                                    &times;
                                </span>
                            </button>
                        </div>
                        <div className="modal-body" style={{ height: 660, maxHeight: 660 }}>
                            <div className="contanier">
                                <div className="row justify-content-around mb-2">
                                    <div className="col-6 font-weight-bold">
                                        {preUploadedFiles.length} Archivos cargados
                                    </div>
                                    <div className="col-6 text-right">
                                        <div>
                                            {(preUploadedFiles.length > 0) &&
                                                <button className="btn btn-primary text-white" type="button" title="Limpiar archivos" onClick={this.cleanFiles}>
                                                    <i className="fas fa-broom" />
                                                </button>
                                            }
                                            <button className="btn botonCorrect text-white ml-2" type="button" title="Subir archivos" onClick={ () => $("#fileUploadInput").trigger("click") }>
                                                <i className="fas fa-upload" aria-hidden="true" size="10" />
                                            </button>
                                            <input className="d-none" id="fileUploadInput" type='file' accept=".txt" multiple onChange={this.preloadFiles} value=""/>
                                        </div>
                                    </div>
                                </div>
                                <hr/>
                                <div className="row justify-content-around mb-2">
                                    <div className="col-12">
                                        <div className="table response" style={{marginBottom: 0}}>
                                            <div
                                                className="w-100 table-scroll tab-pane fade show active "
                                                id="dataContenido"
                                                aria-labelledby="nav-home-tab-Contenido"
                                                style={{maxHeight: 490}}>
                                                <table
                                                    id="dataTableDocuments"
                                                    className="display"
                                                    style={{width: '100%', marginBottom: 40, marginRight: -2000}}>
                                                    <thead className="table-header-yellow">
                                                        <tr style={{ backgroundColor: '#d2ab24', textAlign: "center" }}>
                                                            <td> Nombre </td>
                                                            <td> Tamaño </td>
                                                            <td> Estatus </td>
                                                            <td> Detalles </td>
                                                            <th> Acciones </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                    {preUploadedFiles.map((file, index) => {
                                                        return (
                                                        <tr>
                                                            <td>{file.name}</td>
                                                            <td className='text-center'>({file.size} bytes)</td>
                                                            <td className='text-center'>
                                                                {file.phase === -1 && 'Error al procesarlo'}
                                                                {file.phase === 0 && 'Por subir'}
                                                                {file.phase === 1 && 'Subiendo'}
                                                                {file.phase === 2 && 'Archivo cargado correctamente'}
                                                                {file.phase === 3 && 'Procesando...'}
                                                                {file.phase === 4 && 'Pago conciliado'}
                                                            </td>
                                                            <td className='text-left'>{file.message}</td>
                                                            <td className='text-center'>
                                                                <button
                                                                    type="button"
                                                                    style={{ backgroundColor: 'transparent', padding: 5, color: '#c42222', paddingTop: 2, paddingBottom: 2, }}
                                                                    className="btn"
                                                                    onClick={() => this.unloadFiles(index)}
                                                                    >
                                                                    <i className="fas fa-trash-alt" aria-hidden="true" size="10" />
                                                                </button>
                                                            </td>
                                                        </tr>
                                                        );
                                                    })}
                                                    </tbody>
                                                </table>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            {showConciliaButton && 
                                <button
                                    type="button"
                                    className="btn botonCorrect"
                                    onClick={this.uploadFiles}>
                                    Conciliar pagos
                                </button>
                            }
                            <button
                                type="button"
                                className="btn botonCerrar text-white"
                                onClick={this.closeModal}>
                                Cerrar
                            </button>
                        </div>

                    </div>
                </div>
            </div>
        );
    }
    //#endregion

}
const mapStateToProps = store => {
    return { notificationReducer: store.NotificationReducer };
};

export default connect(
    mapStateToProps
)(FileUploaderModal);
